module.exports = __webpack_public_path__ + "static/world-vector-dark-65c9244cf706daa9501636ce80f6f9e8.png";